import { useEffect } from 'react';
import { api } from '@/lib/api';

const STORAGE_KEY = 'anon_visitor_id';
const PING_INTERVAL = 60_000; // 1 minute

function makeId() {
  // Avoid crypto.randomUUID dependency for older browsers
  return 'v_' + Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
}

function getVisitorId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = makeId();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch (_e) {
    return makeId(); // fallback when localStorage is blocked
  }
}

// Ping the backend periodically so admins can see active anonymous visitors.
// Only activates when `enabled` is true (i.e., no authenticated user).
export function useVisitorTracking(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    const id = getVisitorId();
    let cancelled = false;
    const ping = () => {
      if (cancelled) return;
      api.post('/visitors/ping', { visitor_id: id })
        .catch((err) => { console.warn('[Visitor] ping failed:', err); });
    };
    ping();
    const interval = setInterval(ping, PING_INTERVAL);
    const onFocus = () => ping();
    window.addEventListener('focus', onFocus);
    return () => {
      cancelled = true;
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [enabled]);
}
